import { render, staticRenderFns } from "./ModalAustralianResidencyStatusNew.vue?vue&type=template&id=014e664f&"
import script from "./ModalAustralianResidencyStatusNew.vue?vue&type=script&lang=js&"
export * from "./ModalAustralianResidencyStatusNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports